export const REQUEST_ERRORS_CODES = {
  CIRCUIT_IS_OPEN: 'CIRCUIT_IS_OPEN',
}
